const ContactUs = ({ text = 'cdp-support@ikala.tv' }: { text?: string }) => (
  <a href="mailto:cdp-support@ikala.tv">{text}</a>
)

export default ContactUs
